import { ChangeEventHandler, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectStockAddressingFile } from '../../StockAddressingInBatchSelectors'
import { actions } from '../../StockAddressingInBatchState'
import { validTypes } from './StockAddressingFileInput.data'
import * as S from './StockAddressingFileInput.styles'
import ErrorMessage from 'src/components/ErrorMessage'

export default () => {
  const dispatch = useDispatch()
  const file = useSelector(selectStockAddressingFile)
  const [showError, setShowError] = useState<boolean>(false)
  const inputFileRef = useRef<HTMLInputElement | null>()

  const isValidFile = (testFile: File) => validTypes.includes(testFile.type)

  const clearFile = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = ''
    }
  }

  if (!file) {
    clearFile()
  }

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    event.preventDefault()
    const fileInput = event?.target?.files?.[0] as File

    if (!isValidFile(fileInput)) {
      setShowError(true)
      clearFile()
      dispatch(actions.setStockAddressingFile(undefined))
      return
    }

    dispatch(actions.setStockAddressingFile(fileInput))

    setShowError(false)
  }

  return (
    <S.Form>
      <S.Label htmlFor='file'>
        Arquivo Excel
        <S.Input
          onChange={handleChange}
          type='file'
          name='sheet'
          id='file'
          ref={(ref) => { inputFileRef.current = ref }}
        />
        {showError && (
          <ErrorMessage
            message='É necessário definir um arquivo Excel (.xls, .xlsx) antes de proceder'
          />
        )}
      </S.Label>
    </S.Form>
  )
}
